export default __webpack_public_path__ + "static/media/favoriteKeto.a5fe4cf2.svg";